import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
import { Text } from '@famly/mf_data-display_text';
import { createBox } from '@famly/mf_layout_box';
import { Stack } from '@famly/mf_layout_stack';
const fill = keyframes `
    from {
        transform: scaleX(0);
    }
    to {
        transform: scaleX(1);
    }
`;
// The fill sweeps across on its own clock rather than in steps with the seconds; with reduced motion the button
// stays plain
const Fill = styled(createBox({ position: 'absolute', top: 0, left: 0, bottom: 0, width: '100%' })) `
    transform: scaleX(0);
    transform-origin: left center;

    @media (prefers-reduced-motion: no-preference) {
        && {
            animation: ${fill} ${({ $seconds }) => $seconds}s linear forwards;
        }
    }
`;
/** A button that fills from left to right while a countdown runs out, for an action the screen takes by itself */
export const CountdownFillButton = ({ text, totalSeconds, countdownRun, onClick, variant = 'primary', 'data-e2e-id': dataE2eId, }) => {
    const isPrimary = variant === 'primary';
    return (_jsxs(Stack, { component: "button", type: "button", onClick: onClick, position: "relative", overflow: "hidden", alignItems: "center", justifyContent: "center", minWidth: "160px", minHeight: "48px", paddingX: 6, boxSizing: "border-box", borderRadius: "8px", borderStyle: "none", backgroundColor: isPrimary ? 'p400' : 'p100', cursor: "pointer", "data-e2e-id": dataE2eId, children: [_jsx(Fill, { "$seconds": totalSeconds, backgroundColor: isPrimary ? 'p500' : 'p200', "aria-hidden": "true" }, countdownRun), _jsx(Text, { variant: "body", component: "span", color: isPrimary ? 'n0' : 'n400', emphasized: true, position: "relative", children: text })] }));
};
